import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { DURATIONS, EASING, RADII } from 'styles/consts'

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${RADII.item};
  background: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : COLORS.white};
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? COLORS.borderColor : 'transparent')};
  cursor: pointer;
  transition: background-color ${DURATIONS.fast} ${EASING.out};

  &:hover {
    background: ${COLORS.primaryLight};
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  gap: 4px;
`

export const CheckmarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`
